import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { EnvironmentService } from '@core/services/environment.service';
import { SessionManager } from './session-manager.service';
import { SessionCookieOptions } from '@core/types/session-cookie.interface';

@Injectable()
export class CookieSessionManagerService implements SessionManager {
  private readonly cookieService = inject(CookieService);
  private readonly environmentService = inject(EnvironmentService);
  private readonly cookieOptions: SessionCookieOptions = {
    cookieName: 'cookieBind',
    path: '/',
    domain: location.hostname,
    secure: false,
    httpOnly: false,
    sameSite: 'Lax',
  };

  hasSession(): boolean {
    return this.cookieService.check(this.cookieOptions.cookieName);
  }

  getSession(): string | null {
    return this.cookieService.get(this.cookieOptions.cookieName) || null;
  }

  setSession(value: string, expirationDays: number = 7): void {
    this.cookieService.set(
      this.cookieOptions.cookieName,
      value,
      {
        expires: expirationDays,
        path: this.cookieOptions.path,
        domain: this.cookieOptions.domain,
        secure: this.cookieOptions.secure,
        sameSite: this.cookieOptions.sameSite,
      }
    );
  }

  clearSession(): void {
    this.cookieService.delete(
      this.cookieOptions.cookieName,
      this.cookieOptions.path,
      this.cookieOptions.domain,
      this.cookieOptions.secure,
      this.cookieOptions.sameSite
    );
  }

  refreshSession(expirationDays: number = 7): void {
    const currentValue = this.getSession();
    if (currentValue) {
      this.setSession(currentValue, expirationDays);
    }
  }
}
